import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import BuyCourseActionTypes from './buyCourse.types';
import MyCourseActionTypes from '../myCourse/myCourse.types';
import UtilsTypes from '../utilities/utils.types';
import { clearLocalStorage } from '../../utils/commonFunctions';
import {
	getCurrentProductId,
	getState,
	getOrderId,
} from './buyCourse.selectors';
import Loader from '../../utils/Loader';
import $ from 'jquery';
import { getUserData } from '../userDetails/userDetails.selectors';
import { tagEvent } from '../../utils/tagManager';
import Analytics from '../../utils/Analytics';
import { getCookie } from '../../utils/commonFunctions';
import {
	getParameterByName,
	getSupportPhone,
} from '../../utils/commonFunctions';
import { getChildToken } from '../parentDashboard/parentDashboard.selector';
import { getUserDetails } from '../userAuthentication/userAuth.selectors';
import { getUserType } from '../userAuthentication/userAuth.selectors';
import UserTypes from '../../utils/userTypes';

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

const delay = (duration) =>
	new Promise((resolve) => setTimeout(resolve, duration));

function* pushDatalayer(eventName) {
	const { email, phone } = yield select(getUserData);
	yield call(tagEvent, {
		event: eventName,
		user_id: localStorage.getItem('login_user_id'),
		product_name: localStorage.getItem('gtm_prod_name'),
		coupon_code: localStorage.getItem('gtm_cpn_code'),
		actual_product_value: localStorage.getItem('gtm_prod_price'),
		email: !!email ? email : localStorage.getItem('email'),
		phone: !!phone ? phone : localStorage.getItem('phone'),
		final_product_value: localStorage.getItem('gtm_prod_final'),
		product_id: parseInt(localStorage.getItem('currentProductId'), 10),
		admitad_uid: !!getCookie('admitad_uid') ? getCookie('admitad_uid') : 'step',
	});
}

function* fetchProducts() {
	try {
		const { isInternational } = yield select(getUserDetails);
		let userType = yield select(getUserType);
		let childToken = yield select(getChildToken);
		const res = yield call(Api, {
			url: 'products',
			method: 'GET',
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				yield put({
					type: BuyCourseActionTypes.FETCH_PRODUCT_LIST.SUCCESS,
					payload: res.data.filter((prod) =>
						isInternational
							? prod.country === 0 || prod.country === 2
							: prod.country === 0 || prod.country === 1,
					),
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* fetchRelatedProducts() {
	try {
		const { isInternational } = yield select(getUserDetails);

		const res = yield call(Api, {
			url: 'relatedproducts',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				yield put({
					type: BuyCourseActionTypes.FETCH_RELATED_PRODUCTS.SUCCESS,
					payload: res.data.filter((prod) =>
						isInternational
							? prod.country === 0 || prod.country === 2
							: prod.country === 0 || prod.country === 1,
					),
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* fetchProductDetails() {
	const currentProductId =
		parseInt(getParameterByName('productID'), 10) ||
		(yield select(getCurrentProductId)) ||
		parseInt(localStorage.getItem('currentProductId'), 10);
	const { supportPhone = '9789883344' } = yield select(getUserDetails);
	try {
		let childToken = yield select(getChildToken);
		const res = yield call(Api, {
			url: 'products/' + currentProductId,
			method: 'GET',
			headers: {
				'access-token':
					localStorage.getItem('sso') === '0'
						? localStorage.getItem('token')
						: childToken || localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, getSupportPhone(supportPhone));
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: BuyCourseActionTypes.FETCH_PRODUCT_DETAILS.SUCCESS,
					payload: res.data,
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* validateCoupon({ payload: { couponCode, price } }) {
	const currentProductId =
		parseInt(getParameterByName('productID'), 10) ||
		(yield select(getCurrentProductId)) ||
		parseInt(localStorage.getItem('currentProductId'), 10);

	try {
		let childToken = yield select(getChildToken);
		let { productData: { original_price } = {} } = yield select(getState);
		const res = yield call(Api, {
			url: 'coupon/' + couponCode + '/' + currentProductId,
			method: 'GET',
			headers: {
				'access-token':
					localStorage.getItem('sso') === '0'
						? localStorage.getItem('token')
						: childToken || localStorage.getItem('token'),
			},
		});
		if (!res.status || res.status === 'fail') {
			yield call(setError, res.message);
			yield put({
				type: BuyCourseActionTypes.VALIDATE_COUPON.FAILURE,
				payload: { discountedPrice: '', couponCode: '' },
			});
		} else {
			Loader.hide();
			if (res.code === 200) {
				const {
					discounted_price: discountedPrice,
					discount_price: discountPrice,
				} = res.data;
				if (res.data.result === 'valid') {
					yield call(
						setError,
						`You just saved ₹${original_price - discountedPrice}`,
					);

					if (!!price) {
						yield put({
							type: BuyCourseActionTypes.VALIDATE_COUPON.SUCCESS,
							payload: { discountedPrice, discountPrice },
						});
					} else {
						yield put({
							type: BuyCourseActionTypes.VALIDATE_COUPON.SUCCESS,
							payload: { discountedPrice, discountPrice },
						});
						yield put({
							type: BuyCourseActionTypes.START_TRANSACTION.PENDING,
							payload: { discount_amt: discountedPrice },
						});
					}
				} else {
					yield call(setError, res.message);
					yield put({
						type: BuyCourseActionTypes.VALIDATE_COUPON.FAILURE,
						payload: { discountedPrice: '', couponCode: '' },
					});
				}
			} else {
				yield call(setError, res.message);
				yield put({
					type: BuyCourseActionTypes.VALIDATE_COUPON.FAILURE,
					payload: { discountedPrice: '', couponCode: '' },
				});
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* startTransaction() {
	const prodId =
		parseInt(getParameterByName('productID'), 10) ||
		(yield select(getCurrentProductId)) ||
		parseInt(localStorage.getItem('currentProductId'), 10);

	let coupon = !!getParameterByName('coupon')
		? getParameterByName('coupon')
		: '';
	const {
		stateName,
		couponCode,
		productData: { product_name, offer_price, product_name_slug },
	} = yield select(getState);

	localStorage.setItem('currentProductId', prodId);

	$('#ErrorProduct').hide();
	var is_gst = 'N';
	if (stateName === '') {
		$('#ErrorProduct').html('Please select State');
		$('#ErrorProduct').show();
		Loader.hide();
		return false;
	} else {
		if (stateName === 'Tamil Nadu') {
			is_gst = 'N';
		} else {
			is_gst = 'Y';
		}
	}

	Analytics('purchaseStarted', {
		screen: 'checkoutPage',
		action: 'checkoutClick',
		info: {
			productName: product_name,
			productId: prodId,
			productPrice: offer_price,
			couponCode: !!couponCode ? couponCode : coupon,
		},
		user_id: localStorage.getItem('login_user_id'),
	});

	try {
		let childToken = yield select(getChildToken);
		const res = yield call(Api, {
			url: 'startpayment',
			method: 'POST',
			data: {
				product_id: prodId,
				is_mobile: 'no',
				coupon: !!couponCode ? couponCode : coupon,
				is_gst,
				state_name: stateName,
				is_subscription:
					localStorage.getItem('is_subscription') !== null &&
					localStorage.getItem('is_subscription') !== 'null'
						? localStorage.getItem('is_subscription')
						: 0,
				payment_method:
					localStorage.getItem('payment_method') !== null &&
					localStorage.getItem('payment_method') !== 'null'
						? localStorage.getItem('payment_method')
						: 'DC',
				payment_type: localStorage.getItem('payment_type'),
			},
			headers: {
				'access-token':
					localStorage.getItem('sso') === '0'
						? localStorage.getItem('token')
						: childToken || localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, res);
			yield put({
				type: BuyCourseActionTypes.START_TRANSACTION.FAILURE,
				payload: { discountedPrice: '', couponCode: '' },
			});
		} else {
			if (res.code === 200) {
				const { params, CHECKSUMHASH, payment_type, trans_id } = res.data;
				localStorage.setItem('gtm_prod_name', product_name);
				localStorage.setItem('gtm_cpn_code', !!couponCode ? couponCode : coupon);
				localStorage.setItem('gtm_prod_price', offer_price);
				localStorage.setItem('productNav', product_name_slug);
				localStorage.setItem('gtm_prod_final', Math.floor(res.data.inr_price));
				localStorage.setItem('is_subscription', 0);
				localStorage.setItem('isChildCourse', res.data.isChildCourse);
				localStorage.setItem('txnToken', res.data.txnToken);
				localStorage.setItem('sub_action_url', res.data.sub_action_url);

				const paymentType = localStorage.getItem('payment_type');
				const { email, phone } = yield select(getUserData);
				yield call(tagEvent, {
					event: 'purchase_started',
					user_id: localStorage.getItem('login_user_id'),
					product_name: localStorage.getItem('gtm_prod_name'),
					coupon_code: localStorage.getItem('gtm_cpn_code'),
					actual_product_value: localStorage.getItem('gtm_prod_price'),
					email: !!email ? email : localStorage.getItem('email'),
					phone: !!phone ? phone : localStorage.getItem('phone'),
					final_product_value: localStorage.getItem('gtm_prod_final'),
					product_id: parseInt(localStorage.getItem('currentProductId'), 10),
					admitad_uid: !!getCookie('admitad_uid')
						? getCookie('admitad_uid')
						: 'step',
					order_id: params.ORDER_ID,
					...(!!paymentType &&
						paymentType.toLowerCase() === 'stripe' && {
							final_usd_value: Math.floor(params.TXN_AMOUNT),
						}),
				});
				Loader.show();
				const wait = yield call(delay, 4000);

				Loader.hide();
				yield put({
					type: BuyCourseActionTypes.START_TRANSACTION.SUCCESS,
					payload: {
						paymentData: params,
						checkSum: CHECKSUMHASH,
						payment_type,
						transactionId: trans_id,
						txnToken: localStorage.getItem('txnToken'),
						sub_action_url: localStorage.getItem('sub_action_url'),
					},
				});
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* paymentFail() {
	yield call(pushDatalayer, 'purchase_failure');
	Loader.hide();
	yield put({
		type: BuyCourseActionTypes.PROCESS_PAYMENT.FAILURE,
		payload: false,
	});
	yield put(push('/paymentfailure'));
}

function* paymentSuccess() {
	yield call(pushDatalayer, 'purchase_success');
	Loader.hide();
	yield put({
		type: BuyCourseActionTypes.PROCESS_PAYMENT.SUCCESS,
		payload: true,
	});
	yield put(push('/paymentsuccess'));
}

function* processPayment(orderId) {
	try {
		let childToken = yield select(getChildToken);
		let transactionData = {
			transactionId: orderId,
			transactionTotal: localStorage.getItem('gtm_prod_final'),
			transactionProducts: [
				{
					sku: localStorage.getItem('currentProductId'),
					name: localStorage.getItem('gtm_prod_name'),
					price: parseFloat(localStorage.getItem('gtm_prod_final'), 10),
					quantity: 1,
				},
			],
		};

		const res = yield call(Api, {
			url: 'processpayment',
			method: 'POST',
			data: {
				ORDERID: orderId,
				ISWEB: 'yes',
				payment_type: localStorage.getItem('payment_type'),
			},
			headers: {
				'access-token':
					localStorage.getItem('sso') === '0'
						? localStorage.getItem('token')
						: childToken || localStorage.getItem('token'),
			},
		});
		if (!res.status || res.status === 'fail') {
			Loader.hide();
			if (res.message === 'Payment already processed') {
				yield put(push('/buycourse'));
				yield call(setError, res.message);
			} else if (
				res.message === 'payment failure' ||
				res.message === 'Oops, something went wrong. Please try again' ||
				res === 'Oops, something went wrong. Please try again'
			) {
				yield call(paymentFail);
			} else {
				yield call(tagEvent, transactionData);
				yield call(paymentSuccess);
				if (!!childToken) {
					yield put({ type: MyCourseActionTypes.CHANGE_GRADE.PENDING });
				}
			}
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield call(tagEvent, transactionData);
				yield call(paymentSuccess);
				if (!!childToken) {
					yield put({ type: MyCourseActionTypes.CHANGE_GRADE.PENDING });
				}
			} else {
				yield call(paymentFail);
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* logPayment() {
	const orderId = yield select(getOrderId);
	const { supportPhone = '9789883344' } = yield select(getUserDetails);
	try {
		let childToken = yield select(getChildToken);
		const res = yield call(Api, {
			url: 'log_payment',
			method: 'POST',
			data: {
				log_data: window.location.search.slice(1),
			},
			headers: {
				'access-token':
					localStorage.getItem('sso') === '0'
						? localStorage.getItem('token')
						: childToken || localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setError, getSupportPhone(supportPhone));
		} else {
			if (res.code === 200) {
				Loader.hide();
				if (!!orderId) yield call(processPayment, orderId);
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('buy course', err);
	}
}

function* fetchProductDetailsStart() {
	yield takeLatest(
		BuyCourseActionTypes.FETCH_PRODUCT_DETAILS.PENDING,
		fetchProductDetails,
	);
}

function* fetchProductsStart() {
	yield takeLatest(
		BuyCourseActionTypes.FETCH_PRODUCT_LIST.PENDING,
		fetchProducts,
	);
}

function* validateCouponStart() {
	yield takeLatest(BuyCourseActionTypes.VALIDATE_COUPON.PENDING, validateCoupon);
}

function* startTransactionWatcher() {
	yield takeLatest(
		BuyCourseActionTypes.START_TRANSACTION.PENDING,
		startTransaction,
	);
}

function* processPaymentStart() {
	yield takeLatest(BuyCourseActionTypes.PROCESS_PAYMENT.PENDING, processPayment);
}

function* logPaymentStart() {
	yield takeLatest(BuyCourseActionTypes.LOG_PAYMENT.PENDING, logPayment);
}

function* fetchRelatedProductsStart() {
	yield takeLatest(
		BuyCourseActionTypes.FETCH_RELATED_PRODUCTS.PENDING,
		fetchRelatedProducts,
	);
}

export function* allBuyCourseSagas() {
	yield all([
		call(fetchProductsStart),
		call(fetchProductDetailsStart),
		call(validateCouponStart),
		call(startTransactionWatcher),
		call(processPaymentStart),
		call(logPaymentStart),
		call(fetchRelatedProductsStart),
	]);
}
